document.querySelectorAll('[data-m1v2-specs], [data-m1v2-pricing]').forEach(function (root) {
  var form = root.querySelector('[data-m1v2-contact-form], .m1v2-pricing__form');
  if (!form || form.dataset.m1v2SpecsInit === '1') return;
  form.dataset.m1v2SpecsInit = '1';
  if (form.querySelector('[name="contact[email]"]')) return;

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var name = (form.querySelector('[name="contact_name"]') || {}).value || '';
    var email = (form.querySelector('[name="contact_email"]') || {}).value || '';
    var message = (form.querySelector('[name="contact_message"]') || {}).value || '';
    name = name.trim();
    email = email.trim();
    message = message.trim();
    var to = form.getAttribute('data-support-email') || 'business@joyin.ai';
    var subject = encodeURIComponent('[M1 Support] ' + (name || 'New inquiry'));
    var body = encodeURIComponent('Name: ' + name + '\nEmail: ' + email + '\n\nMessage:\n' + message + '\n');
    window.location.href = 'mailto:' + to + '?subject=' + subject + '&body=' + body;
  });
});
